<template>
  <div>
    <template v-if="trialLessonsUrl">
      <div class="audition-container">
        <video id="audition-video" />
        <div class="audition-video-container">
          <div class="btn-class-tool-video-play" @click="handleVideo" />
          <div class="audition-duration">
            <span v-if="durationHours">{{ durationHours }}:</span>{{ durationMinutes }}:{{ durationSeconds }}
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="container-img" :style="{backgroundImage: `url(${detailData.detailPic || detailData.banners?.[0]})`}" />
    </template>
  </div>
</template>
<script>
import moment from 'moment-timezone'
import bus from 'common/bus'

export default {
  props: {
    detailData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    operation() {
      return JSON.parse(this.detailData.operation || '{}')
    },
    trialLessonsUrl() {
      return this.operation.staticData && this.operation.staticData.trialLessons && this.operation.staticData.trialLessons[0].url
    },
    duration() {
      return this.operation.staticData && this.operation.staticData.trialLessons && this.operation.staticData.trialLessons[0].duration * 1000
    },
    durationHours() {
      let hour = Math.floor(moment.duration(this.duration).asHours());
      hour = hour ? (`${hour}`).padStart(2, '0') : 0;
      return hour
    },
    durationMinutes() {
      let min = moment.duration(this.duration - 3600 * this.durationHours * 1000).minutes();
      min = (`${min}`).padStart(2, '0');
      return min
    },
    durationSeconds() {
      let second = moment.duration(this.duration - 3600 * this.durationHours * 1000 - 60 * this.durationMinutes * 1000).seconds();
      second = (`${second}`).padStart(2, '0');
      return second
    },
  },
  mounted() {
    this.canplay()
  },

  methods: {
    handleVideo() {
      bus.$emit('openVideo', this.trialLessonsUrl)
    },
    canplay() {
      if (!this.trialLessonsUrl) return
      const video = document.getElementById('audition-video')
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      video.src = this.trialLessonsUrl
      video.load()
      setTimeout(() => {
        ctx.drawImage(video, 0, 0);
      }, 500); // 让它等500毫秒再执行以上操作
    },
  },
}
</script>
<style lang="scss" scoped>
  .audition-container,
  .container-img {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 4px;
    width: 392px;
    height: 220px;
    border-radius: 8px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
  }

  #audition-video {
    width: 392px;
    height: 220px;
    border-radius: 8px;
  }

  .audition-container-wrap {
    width: 100%;
  }

  .btn-class-tool-video-play {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 70px;
    height: 70px;
    background: url('~assets/images/our-courses/video-play.png');
    background-size: 100%;
    cursor: pointer;
  }

  .audition-duration {
    position: absolute;
    right: 16px;
    bottom: 10px;
    font-size: 10px;
    font-weight: 500;
    padding: 2px 5px;
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.3);
    color: rgba(255, 255, 255, 1);
    line-height: 12px;
    text-shadow: 0 17px 23px rgba(162, 170, 184, 0.06), 0 17px 23px rgba(162, 170, 184, 0.06);
  }

</style>
